import React from "react";
import "./StaffViewCard.css";

const StaffViewCard = ({
  Name,
  Code,
  Email,
  Phone1,
  Phone2,
  Photo,
  Address,
  IsActive,
  Type,
  JoiningDate,
  BankAccountNumber,
  PanNumber,
  Salary,
}) => {
  const displayValue = (value) => {
    return value !== null && value !== undefined && value !== ""
      ? value
      : "";
  };

  const formattedSalary =
    Salary !== null && Salary !== undefined && Salary !== ""
      ? `Rs. ${Number(Salary).toLocaleString()}`
      : "";

  return (
    <div className="staff-view-card">
      <div className="staff-card-header">
        <div className="staff-photo-wrapper">
          {Photo ? (
            <img
              src={Photo}
              alt={Name || "Staff"}
              className="staff-photo"
            />
          ) : (
            <div className="staff-photo-placeholder">
              {Name ? Name.charAt(0).toUpperCase() : "S"}
            </div>
          )}
        </div>

        <div className="staff-main-info">
          <h2>{displayValue(Name)}</h2>

          {/* <p className="staff-code">
            Code: <span>{displayValue(Code)}</span>
          </p> */}

          <div className="staff-status-row">
            <span
              className={`status-badge ${
                IsActive === "Active" ? "active" : "inactive"
              }`}
            >
              {displayValue(IsActive)}
            </span>

            <span className="type-badge">
              {displayValue(Type)}
            </span>
          </div>
        </div>
      </div>

      <div className="staff-card-body">
        <div className="staff-info-item">
          <span className="staff-label">Email</span>
          <span className="staff-value">{displayValue(Email)}</span>
        </div>

        <div className="staff-info-item">
          <span className="staff-label">Phone 1</span>
          <span className="staff-value">{displayValue(Phone1)}</span>
        </div>

        <div className="staff-info-item">
          <span className="staff-label">Phone 2</span>
          <span className="staff-value">{displayValue(Phone2)}</span>
        </div>

        <div className="staff-info-item">
          <span className="staff-label">Address</span>
          <span className="staff-value">{displayValue(Address)}</span>
        </div>

        <div className="staff-info-item">
          <span className="staff-label">Joining Date</span>
          <span className="staff-value">{displayValue(JoiningDate)}</span>
        </div>

        <div className="staff-info-item">
          <span className="staff-label">Bank Account Number</span>
          <span className="staff-value">
            {displayValue(BankAccountNumber)}
          </span>
        </div>

        <div className="staff-info-item">
          <span className="staff-label">PAN Number</span>
          <span className="staff-value">{displayValue(PanNumber)}</span>
        </div>

        <div className="staff-info-item">
          <span className="staff-label">Salary</span>
          <span className="staff-value salary-value">
            {formattedSalary}
          </span>
        </div>
      </div>
    </div>
  );
};

export default StaffViewCard;